import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConstantsUrl, HttpOptions } from '../utils/constURL';
import { AuthConfig } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient) { }

  // getIP() {
  //   return this.http.get(ConstantsUrl.GET_IP); //cheaper
  // }

  postForgotPassword(data: any) {
    return this.http.post(ConstantsUrl.BASE_URL + ConstantsUrl.FORGOT_PASSWORD, JSON.stringify(data), HttpOptions);
  }

  postVerifyEPassCode(data: any) {
    return this.http.post(ConstantsUrl.BASE_URL + ConstantsUrl.FORGOT_PASSWORD, JSON.stringify(data), HttpOptions);
  }

  postUpdatePwd(data: any) {
    return this.http.post(ConstantsUrl.BASE_URL + ConstantsUrl.FORGOT_PASSWORD, JSON.stringify(data), HttpOptions);
  }

  signIn(loginData: any) {
    return this.http
      .post<any>(ConstantsUrl.BASE_URL + ConstantsUrl.SINGLE_SIGN, JSON.stringify(loginData), HttpOptions)
    /* .map(user => {
      // login successful if there's a jwt token in the response
      if (user && user.Token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('ERuser', JSON.stringify(user.Token));
        // console.log('Token ' + localStorage.getItem('ERuser'));
      }
      return user;
    }); */
  }

  async loadScript() {
    const script = document.createElement('script');
    script.type = "text/javascript";
    script.innerHTML = `
    var $zoho = $zoho || {};
    $zoho.salesiq = $zoho.salesiq || {
      widgetcode: "69179800ae1b4b411cdead9436e48836ad9200283f4fdb6735f04ccab12f3fd9d81cba85562548c769cfaa69ad9b0df8",
      values: {},
      ready: () => { }
    };
    var d = document;
    var s = d.createElement("script");
    s.type = "text/javascript";
    s.id = "zsiqscript";
    s.defer = true;
    s.src = "https://salesiq.zoho.com/widget";
    var t = d.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(s, t);
    d.write("<div id='zsiqwidget'></div>");
    `;

    const head = document.head;
    head.insertBefore(script, head.firstElementChild);
    /* script.innerHTML = `
    var $zoho = $zoho || {};
    $zoho.salesiq = $zoho.salesiq || {
      widgetcode: "69179800ae1b4b411cdead9436e48836ad9200283f4fdb6735f04ccab12f3fd9d81cba85562548c769cfaa69ad9b0df8",
      values: {},
      ready: () => { }
    };
    var d = document;
    var s = d.createElement("script");
    s.type = "text/javascript";
    s.id = "zsiqscript";
    s.defer = true;
    s.src = "https://salesiq.zoho.com/widget";
    var t = d.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(s, t);
    d.write("<div id='zsiqwidget'></div>");
    `; */
    /* const body = document.getElementsByTagName("body")[0];
    body.parentNode.insertBefore(script, body) */
  }

}


export const authCodeFlowConfig: AuthConfig = {
  issuer: 'https://login-std.fifa.org',
  // URL of the SPA to redirect the user to after login
  redirectUri: `${window.location.origin}/login/`,
  clientId: 'f2748f8c-3fea-41dd-b2fc-e89a6927c052',
  dummyClientSecret: 'HQCMaQsg5ERWh74QK4nfT1dkJ8O5Oozn6ROguUnrNJnF4DdQmqcWDuPHgKxGXqgJ',
  responseType: 'code',
  scope: 'openid',
  silentRefreshRedirectUri: `${window.location.origin}/silent-refresh.html`,
  showDebugInformation: true,
  sessionChecksEnabled: true,
  timeoutFactor: 0.01,
  clearHashAfterLogin: false
};


export const authConfig: AuthConfig = {
  issuer: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_CPPQEiOer',
  // URL of the SPA to redirect the user to after login
  redirectUri: `${window.location.origin}/login/`,
  clientId: '70q8foddi4ej5m48ujqlicpq6n',
  responseType: 'code',
  scope: 'aws.cognito.signin.user.admin',
  strictDiscoveryDocumentValidation: false
}